import { Selector } from '@ngxs/store';

import { BcStateListContext } from '@bayclubs/state';
import { ClubModel, ContextCourtModel, EnumerationModel, CategoryOptionsModel, CourtTimeSlotModel } from '@bayclubs/court-booking-employee-api';

import { CoreStateModel } from './core.state.model';
import { CoreState } from './core.state';

export class CoreSelectors {
    @Selector([CoreState])
    static clubs(state: CoreStateModel): BcStateListContext<ClubModel> {
        return state.clubs;
    }

    @Selector([CoreSelectors.clubs])
    static manageableClubs(clubs: BcStateListContext<ClubModel>): ClubModel[] {
        return [...clubs.items];
    }

    @Selector([CoreState])
    static categories(state: CoreStateModel): BcStateListContext<EnumerationModel> {
        return state.categories;
    }

    @Selector([CoreState])
    static courtEventStatuses(state: CoreStateModel): BcStateListContext<EnumerationModel> {
        return state.courtEventStatuses;
    }

    @Selector([CoreState])
    static tennisCourtTypes(state: CoreStateModel): BcStateListContext<EnumerationModel> {
        return state.tennisCourtTypes;
    }

    @Selector([CoreState])
    static categoriesOptions(state: CoreStateModel): BcStateListContext<CategoryOptionsModel> {
        return state.categoriesOptions;
    }

    @Selector([CoreState])
    static courtTimeSlots(state: CoreStateModel): BcStateListContext<CourtTimeSlotModel> {
        return state.courtTimeSlots;
    }

    @Selector([CoreState])
    static courtVisibilityOptions(state: CoreStateModel): BcStateListContext<EnumerationModel> {
        return state.courtVisibilityOptions;
    }

    @Selector([CoreState])
    static selectedClub(state: CoreStateModel): ClubModel {
        return state.selectedClub || state.clubs.items[0];
    }

    @Selector([CoreState])
    static clubCourts(state: CoreStateModel): BcStateListContext<ContextCourtModel> {
      return state.clubCourts;
    }
}
